var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iframeSrc)?_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"680","frameborder":"0","allowfullscreen":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }